export const WORLD_CUP_TEAM_SLUG_MAP: Record<
  string,
  { slug: string; performerId: number | null }
> = {
  mexico: { slug: 'mexico-national-soccer-team', performerId: 30513 },
  'south-korea': {
    slug: 'korea-republic-national-soccer-team',
    performerId: 40785,
  },
  switzerland: { slug: 'switzerland-national-soccer-team', performerId: 40893 },
  'south-africa': {
    slug: 'south-africa-national-soccer-team',
    performerId: 127531,
  },
  canada: { slug: 'canada-national-soccer-team', performerId: 26165 },
  qatar: { slug: 'qatar-national-soccer-team', performerId: 82367 },
  'bosnia-and-herzegovina': {
    slug: 'bosnia-herzegovina-national-soccer-team',
    performerId: null,
  },
  chile: { slug: 'chile-mens-national-soccer', performerId: 15942 },
  brazil: { slug: 'brazil-national-soccer-team', performerId: 115989 },
  morocco: { slug: 'morocco-national-soccer-team', performerId: 82369 },
  scotland: { slug: 'scotland-national-soccer-team', performerId: 14444 },
  haiti: { slug: 'haiti-national-soccer-team', performerId: 39384 },
  'united-states': {
    slug: 'united-states-national-soccer-team',
    performerId: 82262,
  },
  paraguay: { slug: 'paraguay-national-soccer-team', performerId: 21918 },
  australia: { slug: 'australia-national-soccer-team', performerId: 15904 },
  ghana: { slug: 'ghana-national-soccer-team', performerId: 40895 },
  germany: { slug: 'germany-national-soccer-team', performerId: 13795 },
  ecuador: { slug: 'ecuador-national-soccer-team', performerId: 13697 },
  'cote-d-ivoire': {
    slug: 'cote-d-ivoire-national-soccer-team',
    performerId: null,
  },
  curacao: { slug: 'curacao-national-soccer-team', performerId: null },
  netherlands: { slug: 'netherlands-national-soccer-team', performerId: 14222 },
  japan: { slug: 'japan-national-soccer-team', performerId: 21911 },
  tunisia: { slug: 'tunisia-national-soccer-team', performerId: 82368 },
  sweden: { slug: 'sweden-national-soccer-team', performerId: 16197 },
  belgium: { slug: 'belgium-national-soccer-team', performerId: 40896 },
  egypt: { slug: 'egypt-national-soccer-team', performerId: 127527 },
  iran: { slug: 'iran-national-soccer-team', performerId: 5321 },
  'new-zealand': {
    slug: 'new-zealand-national-soccer-team',
    performerId: 31868,
  },
  spain: { slug: 'spain-national-soccer-team', performerId: 14492 },
  uruguay: { slug: 'uruguay-national-soccer-team', performerId: 39587 },
  'saudi-arabia': {
    slug: 'saudi-arabia-national-soccer-team',
    performerId: 82370,
  },
  'cabo-verde': { slug: 'cabo-verde-national-soccer-team', performerId: null },
  france: { slug: 'france-national-soccer-team', performerId: 15995 },
  senegal: { slug: 'senegal-national-soccer-team', performerId: 49627 },
  norway: { slug: 'norway-national-soccer-team', performerId: 128410 },
  peru: { slug: 'peru-national-soccer-team', performerId: 14322 },
  argentina: { slug: 'argentina-national-soccer-team', performerId: 30983 },
  algeria: { slug: 'algeria-national-soccer-team', performerId: 40897 },
  austria: { slug: 'austria-national-soccer-team', performerId: 49357 },
  jordan: { slug: 'jordan-national-soccer-team', performerId: 129794 },
  portugal: { slug: 'portugal-national-soccer-team', performerId: 29518 },
  uzbekistan: { slug: 'uzbekistan-national-soccer-team', performerId: 92712 },
  colombia: { slug: 'colombia-national-soccer-team', performerId: 15950 },
  turkey: { slug: 'turkey-national-soccer-team', performerId: 16209 },
  england: { slug: 'england-national-soccer-team', performerId: 13708 },
  croatia: { slug: 'croatian-national-soccer-team', performerId: 29520 },
  denmark: { slug: 'denmark-national-soccer-team', performerId: 29517 },
  iraq: { slug: 'iraq-national-soccer-team', performerId: 133927 },
};
